"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireLogicService = void 0;
var rule_1 = require("../rule/rule");
var statement_1 = require("../statement/statement");
var outcome_1 = require("../outcome/outcome");
var next_node_1 = require("../questionnaire-path/model/next-node");
var questionnaire_entry_point_1 = require("./questionnaire-entry-point");
var questionnaire_logic_1 = require("./questionnaire-logic");
var node_statements_1 = require("./node-statements");
var questionnaire_condition_context_1 = require("./questionnaire-condition-context");
var lodash_1 = require("lodash");
var publish_1 = require("../condition/publish");
var array_utils_1 = require("../util/array-utils");
var properties_maker_1 = require("../util/properties-maker");
var publish_2 = require("../outcome/publish");
var respondent_knowledge_1 = require("./knowledge/respondent-knowledge");
var answer_condition_context_1 = require("./answer-condition-context");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var node_1 = require("../questionnaire/node");
var constants_1 = require("../constants");
var QuestionnaireLogicService = /** @class */ (function () {
    function QuestionnaireLogicService(statementService, ruleService, outcomeService, questionnaireConditionService) {
        var _this = this;
        this.nodePointTo = function (ql, nodeId, newNextNodeId, shouldUpdateAllStatements) {
            if (!shouldUpdateAllStatements) {
                return _this.updateDefaultStatementOutcomeForNode(ql, nodeId, newNextNodeId);
            }
            var ns = _this.findNodeStatementsByNodeId(ql, nodeId);
            var nodes = ql.questionnaire.nodes;
            var nodeIndex = lodash_1.findIndex(nodes, ['id', nodeId]);
            var nextNode = nodes[nodeIndex + 1];
            var nextNodeId = lodash_1.get(nextNode, 'id', constants_1.FinalNode);
            var newStatements = ns.statements.map(function (statement) {
                var outcome = statement.outcome, id = statement.id, rule = statement.rule;
                // we might change this in the future if we allow outcomes to have empty params.id properties
                // to indicate that a user has not touched the field and therefore we should change it
                var isOutcomeTouched = outcome.params.id !== nextNodeId;
                if (!isOutcomeTouched) {
                    var newOutcome = new outcome_1.Outcome(__assign(__assign({}, outcome), { params: { id: newNextNodeId } }));
                    return new statement_1.Statement({
                        id: id,
                        rule: rule,
                        outcome: newOutcome,
                    });
                }
                return statement;
            });
            var newNodeStatements = node_statements_1.NodeStatements.buildFrom(ns, {
                statements: newStatements,
            });
            var updatedNodeStatements = ql.nodeStatements.map(function (statements) {
                if (statements.nodeId === nodeId) {
                    return newNodeStatements;
                }
                return statements;
            });
            return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
                nodeStatements: updatedNodeStatements,
            });
        };
        this.updateDefaultStatementOutcomeForNode = function (ql, nodeId, nextNodeId) {
            var currentNodePassthrough = _this.findPassthroughStatementByNode(ql, nodeId);
            if (!currentNodePassthrough) {
                throw new advanced_logic_error_1.AdvancedLogicError("Node " + nodeId + " does not contain a default statement");
            }
            var newStatement = new statement_1.Statement({
                outcome: {
                    type: currentNodePassthrough.outcome.type,
                    params: {
                        id: nextNodeId,
                    },
                    reason: currentNodePassthrough.outcome.reason,
                },
            });
            return _this.swapNodeStatement(ql, nodeId, currentNodePassthrough.id, newStatement);
        };
        this.ruleService = ruleService;
        this.statementService = statementService;
        this.outcomeService = outcomeService;
        this.questionnaireConditionService = questionnaireConditionService;
    }
    QuestionnaireLogicService.prototype.evalQStatements = function (qStatements, knowledge) {
        var _this = this;
        var defaultOutcome = new outcome_1.Outcome({
            type: publish_2.OutcomeType.Failure,
            params: new next_node_1.NextNode({ id: constants_1.FinalNode }),
            reason: '',
        });
        var matchingStatement = lodash_1.find(qStatements.statements, function (statement) {
            var outcomeResult = _this.statementService.eval(statement, knowledge);
            return _this.outcomeService.isEvaluatedOutcome(outcomeResult);
        });
        if (matchingStatement) {
            return outcome_1.Outcome.fromOutcomeResult(this.statementService.eval(matchingStatement, knowledge));
        }
        return defaultOutcome;
    };
    QuestionnaireLogicService.prototype.getNextOutcomeForEntryPoint = function (qep, knowledge) {
        var _this = this;
        var evaluatedOutcomeResult = qep.statements
            .map(function (statement) {
            return _this.statementService.eval(statement, knowledge);
        })
            .find(function (outcomeResult) {
            return _this.outcomeService.isEvaluatedOutcome(outcomeResult);
        });
        if (evaluatedOutcomeResult && evaluatedOutcomeResult.outcome) {
            return evaluatedOutcomeResult.outcome;
        }
        else {
            throw new advanced_logic_error_1.AdvancedLogicError('Invalid QuestionnaireEntryPoint.');
        }
    };
    QuestionnaireLogicService.prototype.getOutcome = function (ql, knowledge) {
        var qStatements = this.findNodeStatementsByNodeId(ql, lodash_1.last(knowledge.questionAnswers).questionId);
        return this.evalQStatements(qStatements, knowledge);
    };
    QuestionnaireLogicService.prototype.getOutcomeForNode = function (ql, knowledge, nodeId) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        return this.evalQStatements(qStatements, knowledge);
    };
    QuestionnaireLogicService.prototype.findNodeStatementsByNodeId = function (ql, nodeId) {
        var qStatements = ql.nodeStatements.find(function (qLogic) {
            return qLogic.nodeId === nodeId;
        });
        if (!qStatements) {
            throw new advanced_logic_error_1.AdvancedLogicError("NodeStatements for node " + nodeId + " was not found.");
        }
        return qStatements;
    };
    QuestionnaireLogicService.prototype.findPassthroughStatementByNode = function (ql, nodeId) {
        var nodeStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        return lodash_1.find(nodeStatements.statements, function (statement) { return !statement.rule; });
    };
    QuestionnaireLogicService.prototype.getFollowingNodes = function (ql, nodeId) {
        var questionnaire = ql.questionnaire;
        var nodeIndex = lodash_1.findIndex(questionnaire.nodes, function (node) { return node.id === nodeId; });
        return ql.questionnaire.nodes.filter(function (q, index) { return index >= nodeIndex; });
    };
    QuestionnaireLogicService.prototype.getNode = function (ql, nodeId) {
        var node = ql.questionnaire.nodes.find(function (n) { return n.id === nodeId; });
        if (!node) {
            throw new advanced_logic_error_1.AdvancedLogicError("Node with id " + nodeId + " was not found");
        }
        return node;
    };
    QuestionnaireLogicService.prototype.addNode = function (ql, node, position, shouldUpdateAllStatements) {
        if (shouldUpdateAllStatements === void 0) { shouldUpdateAllStatements = true; }
        var newQl = lodash_1.cloneDeep(ql);
        var nodeId = node.id;
        var nodesLength = lodash_1.get(newQl, 'questionnaire.nodes.length', 0);
        var newPosition = lodash_1.isUndefined(position) ? nodesLength : position;
        if (newPosition > nodesLength) {
            throw new advanced_logic_error_1.AdvancedLogicError("Tried adding a new node to position " + position + ". Current nodes array has a length of " + nodesLength);
        }
        var nextNode, previousNodePassthroughStatement, previousNode;
        if (newPosition === 0) {
            // head_id but always point to the new head question
            var entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                statements: [this.buildPassthroughStatement(nodeId)],
            });
            nextNode = nodesLength > 0 ? newQl.questionnaire.nodes[0].id : constants_1.FinalNode;
            newQl = this.swapEntryPoint(newQl, entryPoint);
        }
        else {
            previousNode = newQl.questionnaire.nodes[newPosition - 1];
            previousNodePassthroughStatement = this.findPassthroughStatementByNode(newQl, previousNode.id);
            nextNode = lodash_1.get(previousNodePassthroughStatement, 'outcome.params.id', constants_1.FinalNode);
        }
        var statement = this.buildPassthroughStatement(nextNode);
        var nodeStatements = new node_statements_1.NodeStatements({
            nodeId: nodeId,
            statements: [statement],
        });
        if (previousNodePassthroughStatement && previousNode) {
            newQl = this.nodePointTo(newQl, previousNode.id, nodeId, shouldUpdateAllStatements);
        }
        // order matters for nodePointTo. The splicing needs to happen after the pointing
        if (!lodash_1.isUndefined(position)) {
            newQl.questionnaire.nodes.splice(position, 0, node);
            newQl.nodeStatements.splice(position, 0, nodeStatements);
        }
        else {
            newQl.questionnaire.nodes.push(node);
            newQl.nodeStatements.push(nodeStatements);
        }
        return newQl;
    };
    QuestionnaireLogicService.prototype.moveNode = function (ql, nodeId, position, shouldUpdateAllStatements) {
        if (shouldUpdateAllStatements === void 0) { shouldUpdateAllStatements = true; }
        var newQl = lodash_1.cloneDeep(ql);
        var nodes = newQl.questionnaire.nodes;
        var currentIndex = lodash_1.findIndex(nodes, ['id', nodeId]);
        var currentNode = nodes[position];
        var order = currentIndex < position ? 'DESC' : 'ASC';
        var previousNode = nodes[currentIndex - 1];
        var nextNode = nodes[currentIndex + 1];
        var nextNodeId = lodash_1.get(nextNode, 'id', constants_1.FinalNode);
        if (order === 'ASC') {
            var currentPreviousNode = nodes[position - 1];
            if (position === 0) {
                // mutate entry point
                var entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                    statements: [this.buildPassthroughStatement(nodeId)],
                });
                newQl = this.swapEntryPoint(newQl, entryPoint);
            }
            else {
                newQl = this.nodePointTo(newQl, currentPreviousNode.id, nodeId, shouldUpdateAllStatements);
            }
            newQl = this.nodePointTo(newQl, nodeId, currentNode.id, shouldUpdateAllStatements);
            newQl = this.nodePointTo(newQl, previousNode.id, nextNodeId, shouldUpdateAllStatements);
        }
        else {
            var currentNextNodeId = lodash_1.get(nodes, "[" + (position + 1) + "].id", constants_1.FinalNode);
            if (currentIndex === 0) {
                var entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                    statements: [this.buildPassthroughStatement(nextNodeId)],
                });
                newQl = this.swapEntryPoint(newQl, entryPoint);
            }
            else {
                newQl = this.nodePointTo(newQl, previousNode.id, nextNodeId, shouldUpdateAllStatements);
            }
            newQl = this.nodePointTo(newQl, nodeId, currentNextNodeId, shouldUpdateAllStatements);
            newQl = this.nodePointTo(newQl, currentNode.id, nodeId, shouldUpdateAllStatements);
        }
        newQl.questionnaire.nodes.splice(position, 0, newQl.questionnaire.nodes.splice(currentIndex, 1)[0]);
        newQl.nodeStatements.splice(position, 0, newQl.nodeStatements.splice(currentIndex, 1)[0]);
        return newQl;
    };
    QuestionnaireLogicService.prototype.removeNodeWithLogic = function (ql, nodeId) {
        var _this = this;
        var newQl = lodash_1.cloneDeep(ql);
        var targetNodeIndex = lodash_1.findIndex(newQl.questionnaire.nodes, [
            'id',
            nodeId,
        ]);
        newQl.questionnaire.nodes = newQl.questionnaire.nodes.filter(function (node) { return node.id !== nodeId; });
        var statementsToRemove = [];
        newQl.nodeStatements.forEach(function (nStatement) {
            nStatement.statements.forEach(function (statement) {
                if (statement.outcome.params.id === nodeId) {
                    // only delete statements that contain rules
                    if (statement.rule) {
                        statementsToRemove.push({
                            statementId: statement.id,
                            nodeId: nStatement.nodeId,
                        });
                    }
                    else {
                        // default statements need to change their nextNodes
                        var nextNode = _this.findPassthroughStatementByNode(newQl, nodeId);
                        if (!nextNode) {
                            throw new advanced_logic_error_1.AdvancedLogicError("No default statement found for node " + nodeId);
                        }
                        var newStatement = new statement_1.Statement(__assign(__assign({}, statement), { outcome: __assign(__assign({}, statement.outcome), { params: {
                                    id: lodash_1.get(nextNode, 'outcome.params.id', constants_1.FinalNode),
                                } }) }));
                        newQl = _this.swapNodeStatement(newQl, nStatement.nodeId, statement.id, newStatement);
                    }
                }
                else if (statement.rule &&
                    _this.ruleService.hasNodeReferences(statement.rule, nodeId)) {
                    statementsToRemove.push({
                        statementId: statement.id,
                        nodeId: nStatement.nodeId,
                    });
                }
            });
        });
        statementsToRemove.forEach(function (_a) {
            var statementId = _a.statementId, nodeId = _a.nodeId;
            // - delete rules
            newQl = _this.deleteStatement(newQl, nodeId, statementId);
        });
        // assume only one entry point for now
        if (newQl.entryPoint.statements[0].outcome.params.id === nodeId) {
            // default statements need to change their nextNodes
            var entryPoint = void 0;
            var nextNode = lodash_1.get(newQl, "questionnaire.nodes[" + targetNodeIndex + "]", null);
            if (nextNode === null) {
                if (newQl.questionnaire.nodes.length !== 0) {
                    throw new advanced_logic_error_1.AdvancedLogicError("New entry point node id not found - checked against " + nodeId);
                }
                else {
                    var nextNodeId = constants_1.FinalNode;
                    entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                        statements: [this.buildPassthroughStatement(nextNodeId)],
                    });
                }
            }
            else {
                entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                    statements: [this.buildPassthroughStatement(nextNode.id)],
                });
            }
            newQl = this.swapEntryPoint(newQl, entryPoint);
        }
        // we need to delete the statement at the end, because we need to find the defaultStatements' nextQ
        newQl.nodeStatements = newQl.nodeStatements.filter(function (nStatements) { return nStatements.nodeId !== nodeId; });
        return newQl;
    };
    QuestionnaireLogicService.prototype.getNodesWithLogic = function (ql) {
        var _this = this;
        var nodesWithLogic = [];
        var allNodes = lodash_1.get(ql, 'questionnaire.nodes', []);
        ql.nodeStatements.forEach(function (nodeStatement) {
            var statementsWithRules = nodeStatement.statements.filter(function (statement) { return statement.rule; });
            var defaultStatement = nodeStatement.statements.find(function (statement) { return !statement.rule; });
            var nodeIndex = lodash_1.findIndex(allNodes, ['id', nodeStatement.nodeId]);
            var nextNodeId = lodash_1.get(allNodes, "[" + (nodeIndex + 1) + "].id", constants_1.FinalNode);
            var hasDefaultStatementLogic = false;
            if (defaultStatement) {
                hasDefaultStatementLogic =
                    defaultStatement.outcome.params.id !== nextNodeId;
            }
            // if a question contains a statement that has any rule, then it is deemed to contain logic
            if (statementsWithRules.length > 0 || hasDefaultStatementLogic) {
                nodesWithLogic.push(nodeStatement.nodeId);
                if (statementsWithRules.length > 0) {
                    statementsWithRules.forEach(function (statement) {
                        if (statement.rule) {
                            var referencedNodes = _this.ruleService.getReferencedNodeIds(statement.rule, nodeStatement.nodeId);
                            nodesWithLogic = nodesWithLogic.concat(referencedNodes);
                        }
                    });
                }
            }
        });
        return lodash_1.uniq(nodesWithLogic);
    };
    QuestionnaireLogicService.prototype.getAnswersWithLogic = function (ql) {
        var _this = this;
        var answersWithLogic = [];
        var textValues = {};
        var allConditions = [];
        ql.nodeStatements.forEach(function (nodeStatement) {
            var statementsWithRules = nodeStatement.statements.filter(function (statement) { return statement.rule; });
            statementsWithRules.forEach(function (statement) {
                var ruleConditions = _this.ruleService.getConditions(statement.rule);
                ruleConditions.forEach(function (condition) {
                    allConditions.push(condition);
                });
            });
        });
        // this will need to be edited in the future to take into account taxonomy context
        allConditions.forEach(function (condition) {
            if (_this.questionnaireConditionService.isAnswerConditionContext(condition)) {
                if (condition.context.valueType === 'text') {
                    var questionId = condition.context.questionId;
                    if (textValues[questionId]) {
                        if (!textValues[questionId].includes(condition.value)) {
                            textValues[questionId].push(condition.value);
                            answersWithLogic.push({
                                questionId: questionId,
                                value: condition.value,
                            });
                        }
                    }
                    else {
                        textValues[questionId] = [condition.value];
                        answersWithLogic.push({
                            questionId: questionId,
                            value: condition.value,
                        });
                    }
                }
                else {
                    answersWithLogic.push(condition.value);
                }
            }
        });
        return lodash_1.uniq(answersWithLogic);
    };
    QuestionnaireLogicService.prototype.getConceptsWithLogic = function (ql) {
        var _this = this;
        var conceptsWithLogic = [];
        var allConditions = [];
        ql.nodeStatements.forEach(function (nodeStatement) {
            var statementsWithRules = nodeStatement.statements.filter(function (statement) { return statement.rule; });
            statementsWithRules.forEach(function (statement) {
                var ruleConditions = _this.ruleService.getConditions(statement.rule);
                ruleConditions.forEach(function (condition) {
                    allConditions.push(condition);
                });
            });
        });
        allConditions.forEach(function (condition) {
            if (_this.questionnaireConditionService.isConceptConditionContext(condition)) {
                conceptsWithLogic.push(condition.value);
            }
        });
        return lodash_1.uniq(conceptsWithLogic);
    };
    QuestionnaireLogicService.prototype.getTaxonomyWithLogic = function (ql) {
        var _this = this;
        var taxonomyKeyValues = {};
        var allConditions = [];
        ql.nodeStatements.forEach(function (nodeStatement) {
            var statementsWithRules = nodeStatement.statements.filter(function (statement) { return statement.rule; });
            statementsWithRules.forEach(function (statement) {
                var ruleConditions = _this.ruleService.getConditions(statement.rule);
                ruleConditions.forEach(function (condition) {
                    allConditions.push(condition);
                });
            });
        });
        allConditions.forEach(function (condition) {
            if (_this.questionnaireConditionService.isTaxonomyConditionContext(condition)) {
                if (taxonomyKeyValues[condition.context.property]) {
                    if (!taxonomyKeyValues[condition.context.property].includes(condition.value)) {
                        taxonomyKeyValues[condition.context.property].push(condition.value);
                    }
                }
                else {
                    taxonomyKeyValues[condition.context.property] = [condition.value];
                }
            }
        });
        return taxonomyKeyValues;
    };
    QuestionnaireLogicService.prototype.getAllConditions = function (ql) {
        var _this = this;
        var allConditions = [];
        var nodeMap = new Map();
        var statementMap = new Map();
        var _a = ql.nodeStatements, nodeStatements = _a === void 0 ? [] : _a;
        nodeStatements.forEach(function (nStatement) {
            nStatement.statements.forEach(function (statement) {
                if (statement.rule) {
                    var ruleConditions = _this.ruleService.getConditions(statement.rule);
                    ruleConditions.forEach(function (condition) {
                        nodeMap.set(condition.id, nStatement.nodeId);
                        statementMap.set(condition.id, statement.id);
                    });
                    allConditions = allConditions.concat(ruleConditions);
                }
            });
        });
        return {
            allConditions: allConditions,
            nodeMap: nodeMap,
            statementMap: statementMap,
        };
    };
    // TODO: this is not performant as it was done rather quicky. It would be fun to revisit it
    QuestionnaireLogicService.prototype.removeAnswerWithLogic = function (ql, nodeId, answerId, scorepointId, updateQuestionnaireNode) {
        var _a;
        if (updateQuestionnaireNode === void 0) { updateQuestionnaireNode = true; }
        if (updateQuestionnaireNode) {
            var node = ql.questionnaire.nodes.find(function (node) { return node.id === nodeId; });
            if (!node) {
                throw new advanced_logic_error_1.AdvancedLogicError("Node with id " + nodeId + " was not found");
            }
            if (!node_1.isQuestion(node)) {
                throw new Error("Expected node of type Question, got node " + node + " instead");
            }
            var question = node;
            if (answerId) {
                question.answers = question.answers.filter(function (answer) { return answer.id !== answerId; });
            }
            if (scorepointId) {
                question.scorepoints = (_a = question.scorepoints) === null || _a === void 0 ? void 0 : _a.filter(function (scorepoint) { return scorepoint.id !== scorepointId; });
            }
        }
        var _b = this.getAllConditions(ql), allConditions = _b.allConditions, nodeMap = _b.nodeMap, statementMap = _b.statementMap;
        var conditionsContainingAnswer = [];
        if (answerId) {
            // - Find all conditions that include that answerId
            conditionsContainingAnswer = allConditions.filter(function (condition) {
                if (condition.context &&
                    (condition.context.valueType === 'matrix' ||
                        condition.context.valueType === 'matrixBipolar' ||
                        condition.context.valueType === 'matrixNumericOpenEnded')) {
                    return condition.value.row === answerId;
                }
                return condition.value === answerId;
            });
        }
        else if (scorepointId) {
            // - Find all conditions that include that scorepointId
            conditionsContainingAnswer = allConditions.filter(function (condition) { return lodash_1.get(condition, 'value.column') === scorepointId; });
        } // [TODO: RES-6666 handle column of new matrices ]
        return this.removeConditions(ql, conditionsContainingAnswer, nodeMap, statementMap);
    };
    QuestionnaireLogicService.prototype.removeConditionsWithProperty = function (ql, propertyToCheck, contextType) {
        var _a = this.getAllConditions(ql), allConditions = _a.allConditions, nodeMap = _a.nodeMap, statementMap = _a.statementMap;
        var conditionsContainingContext = [];
        if (contextType === questionnaire_condition_context_1.QuestionnaireConditionContext.Taxonomy) {
            conditionsContainingContext = allConditions.filter(function (condition) { return condition.context.property === propertyToCheck; });
        }
        else {
            throw new Error("removeContextReferences only expects concept context types currently. Received " + contextType);
        }
        return this.removeConditions(ql, conditionsContainingContext, nodeMap, statementMap);
    };
    QuestionnaireLogicService.prototype.removeConditionsWithValue = function (ql, valueToCheck, contextType) {
        var _a = this.getAllConditions(ql), allConditions = _a.allConditions, nodeMap = _a.nodeMap, statementMap = _a.statementMap;
        var conditionsContainingContext = [];
        if (contextType === questionnaire_condition_context_1.QuestionnaireConditionContext.Concept ||
            contextType === questionnaire_condition_context_1.QuestionnaireConditionContext.Taxonomy) {
            conditionsContainingContext = allConditions.filter(function (condition) { return condition.value === valueToCheck; });
        }
        else {
            throw new Error("removeContextReferences only expects concept context types currently. Received " + contextType);
        }
        return this.removeConditions(ql, conditionsContainingContext, nodeMap, statementMap);
    };
    QuestionnaireLogicService.prototype.removeConditionsWithoutValue = function (ql) {
        var _this = this;
        var _a = this.getAllConditions(ql), allConditions = _a.allConditions, nodeMap = _a.nodeMap, statementMap = _a.statementMap;
        var conditionsWithoutValue = [];
        conditionsWithoutValue = allConditions.filter(function (condition) {
            return lodash_1.isNil(condition.value) ||
                (lodash_1.isString(condition.value) && lodash_1.isEmpty(condition.value));
        });
        if (conditionsWithoutValue.length) {
            var newQl_1 = lodash_1.cloneDeep(ql);
            conditionsWithoutValue.forEach(function (conditionWithouValue) {
                var parentNodeId = nodeMap.get(conditionWithouValue.id);
                var parentStatementId = statementMap.get(conditionWithouValue.id);
                if (!parentNodeId || !parentStatementId) {
                    throw new advanced_logic_error_1.AdvancedLogicError("Missing parent node or parent statement for condition " + conditionWithouValue.id);
                }
                // - get parentNode for each condition found
                var parentRule = _this.getParentNode(newQl_1, parentNodeId, conditionWithouValue);
                if (!parentRule) {
                    throw new advanced_logic_error_1.AdvancedLogicError("No rule was found for condition " + conditionWithouValue.id);
                }
                newQl_1 = _this.deleteCondition(newQl_1, parentNodeId, parentStatementId, parentRule.id, conditionWithouValue.id, true);
            });
            return newQl_1;
        }
        return ql;
    };
    QuestionnaireLogicService.prototype.removeConditions = function (ql, conditions, nodeMap, statementMap) {
        var _this = this;
        var newQl = lodash_1.cloneDeep(ql);
        var rulesToDelete = [];
        conditions.forEach(function (condition) {
            var parentNodeId = nodeMap.get(condition.id);
            var parentStatementId = statementMap.get(condition.id);
            if (!parentNodeId || !parentStatementId) {
                throw new advanced_logic_error_1.AdvancedLogicError("Missing parent node or parent statement for condition " + condition.id);
            }
            // - get parentNode for each condition found
            var parentRule = _this.getParentNode(newQl, parentNodeId, condition);
            if (!parentRule) {
                throw new advanced_logic_error_1.AdvancedLogicError("No rule was found for condition " + condition.id);
            }
            // there is no way to get a Statement or a Condition when getting the parent of a condition
            rulesToDelete.push({
                nodeId: parentNodeId,
                statementId: parentStatementId,
                ruleId: parentRule.id,
            });
        });
        var filteredRules = lodash_1.uniqBy(rulesToDelete, 'ruleId');
        filteredRules.forEach(function (_a) {
            var statementId = _a.statementId, nodeId = _a.nodeId, ruleId = _a.ruleId;
            // - delete rules
            newQl = _this.deleteRule(newQl, nodeId, statementId, ruleId, true);
        });
        return newQl;
    };
    QuestionnaireLogicService.prototype.prependNodeStatement = function (ql, nodeId, statement) {
        return this.addNodeStatement(ql, nodeId, statement, 0);
    };
    QuestionnaireLogicService.prototype.appendNodeStatement = function (ql, nodeId, statement) {
        return this.addNodeStatement(ql, nodeId, statement);
    };
    QuestionnaireLogicService.prototype.addNodeStatement = function (ql, nodeId, statement, position) {
        var nodeStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var newStatements = __spreadArrays(nodeStatements.statements);
        if (lodash_1.isNumber(position)) {
            newStatements.splice(position, 0, statement);
        }
        else {
            // we need to always keep the default statement last. This is assuming that the default statement
            // is the last one already
            newStatements.splice(newStatements.length - 1, 0, statement);
        }
        var newNodeStatements = node_statements_1.NodeStatements.buildFrom(nodeStatements, {
            statements: newStatements,
        });
        var updatedNodeStatements = ql.nodeStatements.map(function (statements) {
            if (statements.nodeId === nodeId) {
                return newNodeStatements;
            }
            return statements;
        });
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            nodeStatements: updatedNodeStatements,
        });
    };
    QuestionnaireLogicService.prototype.removeStatementFromNodeStatements = function (ql, nodeId, statementId) {
        var qs = this.findNodeStatementsByNodeId(ql, nodeId);
        var newQuestionStatement = node_statements_1.NodeStatements.buildFrom(qs, {
            statements: array_utils_1.ArrayUtils.removeBy(qs.statements, 'id', statementId),
        });
        var updatedNodeStatements = ql.nodeStatements.map(function (nodeStatement) {
            if (nodeStatement.nodeId === nodeId) {
                return newQuestionStatement;
            }
            return nodeStatement;
        });
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            nodeStatements: updatedNodeStatements,
        });
    };
    QuestionnaireLogicService.prototype.deleteStatement = function (ql, nodeId, statementId) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var newNodeStatements = node_statements_1.NodeStatements.buildFrom(qStatements, {
            statements: array_utils_1.ArrayUtils.removeBy(qStatements.statements, 'id', statementId),
        });
        return this.swapNodeStatements(ql, nodeId, newNodeStatements);
    };
    QuestionnaireLogicService.prototype.swapNodeStatements = function (ql, nodeId, qStatements) {
        var updatedNodeStatements = ql.nodeStatements.map(function (statements) {
            if (statements.nodeId === nodeId) {
                return qStatements;
            }
            return statements;
        });
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            nodeStatements: updatedNodeStatements,
        });
    };
    QuestionnaireLogicService.prototype.addStatementToNodeStatements = function (ql, nodeId, statement) {
        var qs = this.findNodeStatementsByNodeId(ql, nodeId);
        var updatedNodeStatements = ql.nodeStatements.map(function (statements) {
            if (statements.nodeId !== nodeId) {
                return statements;
            }
            var newNodeStatements = node_statements_1.NodeStatements.buildFrom(qs, {
                statements: __spreadArrays(qs.statements, [statement]),
            });
            return newNodeStatements;
        });
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            nodeStatements: updatedNodeStatements,
        });
    };
    QuestionnaireLogicService.prototype.removeStatementFromEntryPoint = function (ql, statementId) {
        var statements = ql.entryPoint.statements;
        var updatedStatements = array_utils_1.ArrayUtils.removeBy(statements, 'id', statementId);
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            entryPoint: questionnaire_entry_point_1.QuestionnaireEntryPoint.buildFrom(ql.entryPoint, {
                statements: updatedStatements,
            }),
        });
    };
    QuestionnaireLogicService.prototype.swapNodeStatement = function (ql, nodeId, statementId, newStatement) {
        var qs = this.findNodeStatementsByNodeId(ql, nodeId);
        var newStatements = qs.statements.map(function (statement) {
            if (statement.id === statementId) {
                return newStatement;
            }
            return statement;
        });
        var newNodeStatements = node_statements_1.NodeStatements.buildFrom(qs, {
            statements: newStatements,
        });
        var updatedNodeStatements = ql.nodeStatements.map(function (statements) {
            if (statements.nodeId === nodeId) {
                return newNodeStatements;
            }
            return statements;
        });
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            nodeStatements: updatedNodeStatements,
        });
    };
    QuestionnaireLogicService.prototype.updateOutcome = function (ql, nodeId, statementId, outcome) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        var newOutcome = new outcome_1.Outcome(__assign(__assign({}, oldStatement.outcome), outcome));
        var newStatement = new statement_1.Statement({
            id: oldStatement.id,
            rule: oldStatement.rule,
            outcome: newOutcome,
        });
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.swapEntryPoint = function (ql, entryPoint) {
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            entryPoint: entryPoint,
        });
    };
    QuestionnaireLogicService.prototype.getParentNode = function (ql, nodeId, node) {
        var _this = this;
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var parentNode;
        qStatements.statements.some(function (statement) {
            parentNode = _this.getParentNodeFromStatement(statement, nodeId, node);
            return parentNode;
        });
        return parentNode;
    };
    QuestionnaireLogicService.prototype.getParentNodeFromStatement = function (statement, nodeId, node) {
        var _this = this;
        var rootRule = statement.rule;
        if (!rootRule) {
            return;
        }
        if (this.ruleService.isCondition(node)) {
            var condition = node;
            if (this.ruleService.includes(rootRule, condition.id)) {
                return rootRule;
            }
            var parentNode_1;
            var traverse_1 = function (conditionOrRule) {
                if (_this.ruleService.isRule(conditionOrRule)) {
                    if (_this.ruleService.includes(conditionOrRule, node.id)) {
                        parentNode_1 = conditionOrRule;
                    }
                    else {
                        conditionOrRule.conditions.forEach(traverse_1);
                    }
                }
            };
            rootRule.conditions.forEach(traverse_1);
            return parentNode_1;
        }
        else if (this.ruleService.isRule(node)) {
            if (rootRule.id === node.id) {
                return statement;
            }
            return this.ruleService.getParentRuleFromRule(rootRule, node.id);
        }
        else if (this.statementService.isStatement(node)) {
            throw new advanced_logic_error_1.AdvancedLogicError('Getting a parent node of a statement is not supported yet. Please consider updating it');
        }
        else {
            throw new advanced_logic_error_1.AdvancedLogicError("Provided node " + node + " does not conform to any known model (ie: Rule, Condition, Statement)");
        }
    };
    QuestionnaireLogicService.prototype.swapStatementRule = function (ql, nodeId, statementId, newRule) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var statement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!statement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " was not found");
        }
        var newStatement = new statement_1.Statement({
            id: statement.id,
            outcome: statement.outcome,
            rule: newRule,
        });
        return this.swapNodeStatement(ql, nodeId, statement.id, newStatement);
    };
    QuestionnaireLogicService.prototype.swapCondition = function (ql, nodeId, conditionId, newCondition) {
        var _this = this;
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var statementWithCondition = qStatements.statements.find(function (statement) {
            if (statement.rule) {
                var conditions = _this.ruleService.getConditions(statement.rule);
                return lodash_1.find(conditions, ['id', conditionId]);
            }
            return false;
        });
        if (!statementWithCondition || !statementWithCondition.rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Condition with id " + conditionId + " not found on provided QuestionnaireLogic");
        }
        var conditionUpdater = function (conditionOrRule) {
            if (_this.ruleService.isRule(conditionOrRule)) {
                return conditionUpdater(conditionOrRule);
            }
            if (conditionOrRule.id === conditionId) {
                return newCondition;
            }
            return conditionOrRule;
        };
        var rootRule = statementWithCondition.rule;
        var newConditions = rootRule.conditions.map(conditionUpdater);
        var newStatement = new statement_1.Statement({
            id: statementWithCondition.id,
            rule: new rule_1.Rule({
                id: rootRule.id,
                operator: rootRule.operator,
                conditions: newConditions,
            }),
            outcome: statementWithCondition.outcome,
        });
        var newStatements = node_statements_1.NodeStatements.buildFrom(qStatements, {
            statements: lodash_1.merge(qStatements.statements, newStatement),
        });
        var updatedNodeStatements = ql.nodeStatements.map(function (statements) {
            if (statements.nodeId === nodeId) {
                return newStatements;
            }
            return statements;
        });
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            nodeStatements: updatedNodeStatements,
        });
    };
    QuestionnaireLogicService.prototype.addEntryPointStatement = function (ql, statement, position) {
        var entryPointStatements = ql.entryPoint.statements;
        entryPointStatements.splice(position, 0, statement);
        return questionnaire_logic_1.QuestionnaireLogic.buildFrom(ql, {
            entryPoint: questionnaire_entry_point_1.QuestionnaireEntryPoint.buildFrom(ql.entryPoint, {
                statements: entryPointStatements,
            }),
        });
    };
    QuestionnaireLogicService.prototype.addCondition = function (ql, nodeId, statementId, ruleId, condition, cascade) {
        if (cascade === void 0) { cascade = true; }
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        var newStatement = new statement_1.Statement(lodash_1.cloneDeep(oldStatement));
        newStatement = this.addConditionToStatement(newStatement, nodeId, ruleId, condition, cascade);
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.addConditionToStatement = function (statement, nodeId, ruleId, condition, cascade) {
        if (cascade === void 0) { cascade = true; }
        var rule = this.ruleService.getRuleById(statement, ruleId);
        if (!rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule " + ruleId + " not found under statement " + statement.id);
        }
        if (cascade && rule.conditions.length >= 2) {
            var newStatement = lodash_1.cloneDeep(statement);
            var parentNode = (this.getParentNodeFromStatement(newStatement, nodeId, rule));
            var newRule = new rule_1.Rule({
                operator: rule.operator,
                conditions: [condition],
            });
            var newRoot_1 = new rule_1.Rule({
                operator: rule.operator,
                conditions: [rule, newRule],
            });
            // if this is a rule
            if (parentNode.operator) {
                parentNode.conditions = parentNode.conditions.map(function (conditionOrRule) {
                    if (conditionOrRule.id === ruleId) {
                        return newRoot_1;
                    }
                    return conditionOrRule;
                });
                // if this is a statement
            }
            else if (parentNode.outcome) {
                newStatement.rule = newRoot_1;
            }
            return newStatement;
        }
        rule.conditions.push(condition);
        return statement;
    };
    QuestionnaireLogicService.prototype.deleteCondition = function (ql, nodeId, statementId, ruleId, conditionId, recursiveDelete) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        var newStatement = new statement_1.Statement(lodash_1.cloneDeep(oldStatement));
        if (!newStatement.rule)
            return ql;
        // sorry TS :(
        var foundRule = this.ruleService.getRuleById(newStatement, ruleId);
        foundRule.conditions = foundRule.conditions.filter(function (condition) { return condition.id !== conditionId; });
        if (lodash_1.isEmpty(foundRule.conditions) && recursiveDelete) {
            return this.deleteRule(ql, nodeId, statementId, ruleId, recursiveDelete);
        }
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.updateCondition = function (ql, nodeId, statementId, ruleId, updatedCondition) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        // TODO: stop cloneDeep to enforce immutability
        var newStatement = new statement_1.Statement(lodash_1.cloneDeep(oldStatement));
        // sorry TS :(
        var rule = this.ruleService.getRuleById(newStatement, ruleId);
        if (!rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule " + ruleId + " not found under statement " + statementId);
        }
        rule.conditions = rule.conditions.map(function (conditionOrRule) {
            if (conditionOrRule.id === updatedCondition.id) {
                var condition = conditionOrRule;
                // this is here to help the API handle partial updates better
                if (!updatedCondition.context && condition.context) {
                    var value = updatedCondition.value;
                    var valueType = typeof value;
                    var isNullRelatedMatcher = [
                        publish_1.Matcher.IsNull,
                        publish_1.Matcher.IsNotNull,
                    ].some(function (matcher) { return matcher === updatedCondition.matcher; });
                    if (valueType === 'object' && value instanceof Array) {
                        valueType = 'array';
                    }
                    if (valueType === 'object' &&
                        lodash_1.has(value, 'row') &&
                        lodash_1.has(value, 'column')) {
                        valueType = 'matrix';
                    }
                    if (valueType === 'object' &&
                        lodash_1.has(value, 'row') &&
                        lodash_1.has(value, 'number') &&
                        !lodash_1.has(value, 'column')) {
                        valueType = 'matrixBipolar';
                    }
                    if (valueType === 'object' &&
                        lodash_1.has(value, 'row') &&
                        lodash_1.has(value, 'column') &&
                        (lodash_1.has(value, 'number') ||
                            (!lodash_1.has(value, 'number') && isNullRelatedMatcher))) {
                        valueType = 'matrixNumericOpenEnded';
                    }
                    var newContext = new answer_condition_context_1.AnswerConditionContext(condition.context.questionId, valueType);
                    var newCondition = new publish_1.Condition(lodash_1.merge(condition, updatedCondition, {
                        context: newContext,
                    }));
                    return newCondition;
                }
                return publish_1.Condition.buildFrom(condition, updatedCondition);
            }
            return conditionOrRule;
        });
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.updateRuleConditions = function (ql, nodeId, statementId, ruleId, conditions) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        // TODO: stop cloneDeep to enforce immutability
        var newStatement = new statement_1.Statement(lodash_1.cloneDeep(oldStatement));
        // sorry TS :(
        var rule = this.ruleService.getRuleById(newStatement, ruleId);
        if (!rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule " + ruleId + " not found under statement " + statementId);
        }
        rule.conditions = conditions;
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.addRule = function (ql, nodeId, statementId, newRule, ruleId) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        if (!ruleId) {
            var newConditions = [newRule];
            if (oldStatement.rule) {
                newConditions.unshift(oldStatement.rule);
            }
            var newStatementRule = new rule_1.Rule({
                operator: publish_1.Operator.Any,
                conditions: newConditions,
            });
            var newStatement_1 = new statement_1.Statement({
                id: oldStatement.id,
                rule: newStatementRule,
                outcome: oldStatement.outcome,
            });
            return this.swapNodeStatement(ql, nodeId, statementId, newStatement_1);
        }
        // TODO: stop cloneDeep to enforce immutability
        var newStatement = new statement_1.Statement(lodash_1.cloneDeep(oldStatement));
        var rule = this.ruleService.getRuleById(newStatement, ruleId);
        if (!rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule " + ruleId + " not found under statement " + statementId);
        }
        // sorry TS :(
        var parentNode = (this.getParentNodeFromStatement(newStatement, nodeId, rule));
        if (!parentNode) {
            throw new advanced_logic_error_1.AdvancedLogicError("Could not find the parent node of rule " + ruleId);
        }
        parentNode.rule = new rule_1.Rule({
            operator: publish_1.Operator.Any,
            conditions: [rule, newRule],
        });
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.deleteRule = function (ql, nodeId, statementId, ruleId, deleteStatement) {
        var _this = this;
        if (deleteStatement === void 0) { deleteStatement = false; }
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        // sorry TS :(
        var newStatement = lodash_1.cloneDeep(oldStatement);
        if (!newStatement.rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule " + ruleId + " not found under statement " + statementId);
        }
        var rule = this.ruleService.getRuleById(newStatement, ruleId);
        var removeElements = function (ruleNode) {
            // sorry TS :(
            var parentNode = (_this.getParentNodeFromStatement(newStatement, nodeId, ruleNode));
            if (!parentNode) {
                throw new advanced_logic_error_1.AdvancedLogicError("No parentNode found for node " + nodeId + " and rule " + ruleNode.id);
            }
            // stupid way of overriding the fact that the `isStatement` method will return a statement with a readonly prop
            if (lodash_1.has(parentNode, 'rule')) {
                delete newStatement.rule;
            }
            else {
                parentNode.conditions = parentNode.conditions.filter(function (condition) { return condition.id !== ruleId; });
                // if we empty out a rule on deletion, we should completely erase this rule
                if (lodash_1.isEmpty(parentNode.conditions)) {
                    removeElements(parentNode);
                }
                else if (parentNode.conditions.length === 1 &&
                    lodash_1.has(parentNode.conditions[0], 'operator')) {
                    var grandparent = (_this.getParentNodeFromStatement(newStatement, nodeId, parentNode));
                    if (!grandparent) {
                        console.warn('Could not find grandparent node', parentNode);
                        return;
                    }
                    if (lodash_1.has(grandparent, 'operator')) {
                        // add parentNodes child to its grandparent since we now have a reduntant Rule
                        grandparent.conditions = grandparent.conditions.map(function (condition) {
                            if (condition.id === parentNode.id) {
                                return parentNode.conditions[0];
                            }
                            return condition;
                        });
                    }
                    else if (lodash_1.has(grandparent, 'outcome')) {
                        grandparent.rule = parentNode.conditions[0];
                    }
                }
            }
        };
        removeElements(rule);
        if (!newStatement.rule && deleteStatement) {
            return this.removeStatementFromNodeStatements(ql, nodeId, statementId);
        }
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.updateRuleOperator = function (ql, nodeId, statementId, ruleId, operator) {
        var qStatements = this.findNodeStatementsByNodeId(ql, nodeId);
        var oldStatement = lodash_1.find(qStatements.statements, ['id', statementId]);
        if (!oldStatement) {
            throw new advanced_logic_error_1.AdvancedLogicError("Statement with id " + statementId + " not found for node " + nodeId);
        }
        var newStatement = new statement_1.Statement(lodash_1.cloneDeep(oldStatement));
        var rule = this.ruleService.getRuleById(newStatement, ruleId);
        rule.operator = operator;
        // const newStatement = produce(oldStatement, (draft) => {
        //   const rule = <any>this.ruleService.getRuleById(draft, ruleId);
        //   rule.operator = operator;
        // });
        return this.swapNodeStatement(ql, nodeId, statementId, newStatement);
    };
    QuestionnaireLogicService.prototype.addEmptyRule = function (ql, nodeId, statementId, ruleId) {
        var newRule = this.buildDefaultRule(nodeId);
        return this.addRule(ql, nodeId, statementId, newRule, ruleId);
    };
    QuestionnaireLogicService.prototype.addEmptyCondition = function (ql, nodeId, statementId, ruleId, cascade) {
        var newCondition = this.questionnaireConditionService.createAnswerConditionEqual(nodeId, '');
        return this.addCondition(ql, nodeId, statementId, ruleId, newCondition, cascade);
    };
    QuestionnaireLogicService.prototype.buildDefaultQuestionnaireLogic = function (questionnaire, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, defaultMatcher = _b.defaultMatcher, _c = _b.expandConditions, expandConditions = _c === void 0 ? true : _c, _d = _b.cascade, cascade = _d === void 0 ? false : _d;
        if (lodash_1.isEmpty(questionnaire.nodes)) {
            var entryPoint_1 = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                statements: [this.buildPassthroughStatement(constants_1.FinalNode)],
            });
            return new questionnaire_logic_1.QuestionnaireLogic({
                questionnaire: properties_maker_1.PropertiesMaker.merge(questionnaire, { nodes: [] }),
                nodeStatements: [],
                entryPoint: entryPoint_1,
            });
        }
        var nodeStatements = questionnaire.nodes.map(function (node, index) {
            var nodeId = node.id;
            var expectedNextNode = questionnaire.nodes[index + 1];
            var expectedNextNodeId = lodash_1.get(expectedNextNode, 'id', constants_1.FinalNode);
            if (!node_1.isQuestion(node) || lodash_1.isEmpty(node.answers)) {
                var defaultStatement = _this.buildPassthroughStatement(expectedNextNodeId);
                return new node_statements_1.NodeStatements({
                    nodeId: node.id,
                    statements: [defaultStatement],
                });
            }
            var question = node;
            var groupedNextQs = lodash_1.groupBy(question.answers, 'nextQuestion');
            var pairs = lodash_1.toPairs(groupedNextQs);
            var statements = [];
            pairs.forEach(function (pair) {
                var nextQuestionId = pair[0];
                if (nextQuestionId === expectedNextNodeId && !expandConditions) {
                    return;
                }
                var answers = pair[1];
                var answerIds = answers.map(function (a) {
                    return a.id;
                });
                statements.push(_this.buildDefaultStatement(nodeId, nextQuestionId, answerIds, undefined, defaultMatcher, cascade));
            });
            if (!expandConditions) {
                // a default statement is always created for "any" cases
                var defaultStatement = _this.buildPassthroughStatement(expectedNextNodeId);
                statements.push(defaultStatement);
            }
            return new node_statements_1.NodeStatements({
                nodeId: question.id,
                statements: statements,
            });
        });
        var firstNode = questionnaire.nodes[0];
        var entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
            statements: [this.buildPassthroughStatement(firstNode.id)],
        });
        return new questionnaire_logic_1.QuestionnaireLogic({
            questionnaire: questionnaire,
            nodeStatements: nodeStatements,
            entryPoint: entryPoint,
        });
    };
    QuestionnaireLogicService.prototype.buildDefaultStatement = function (nodeId, nextNode, answerIds, id, defaultMatcher, cascade) {
        var _this = this;
        if (defaultMatcher === void 0) { defaultMatcher = publish_1.Matcher.In; }
        if (cascade === void 0) { cascade = true; }
        var rule;
        if (defaultMatcher === publish_1.Matcher.In) {
            var condition = this.questionnaireConditionService.createAnswerConditionIn(nodeId, answerIds, id);
            rule = new rule_1.Rule({
                id: id,
                operator: publish_1.Operator.Any,
                conditions: [condition],
            });
        }
        else if (defaultMatcher === publish_1.Matcher.Equal) {
            if (!cascade) {
                var conditions = answerIds.map(function (answerId) {
                    var condition = _this.questionnaireConditionService.createAnswerConditionEqual(nodeId, answerId, id);
                    return condition;
                });
                rule = new rule_1.Rule({
                    id: id,
                    operator: publish_1.Operator.Any,
                    conditions: conditions,
                });
            }
            else {
                var statement_2 = new statement_1.Statement({
                    id: id,
                    rule: new rule_1.Rule({
                        id: id,
                        operator: publish_1.Operator.Any,
                        conditions: [],
                    }),
                    outcome: new outcome_1.Outcome({
                        type: publish_2.OutcomeType.Success,
                        params: new next_node_1.NextNode({
                            id: nextNode,
                        }),
                        reason: '',
                    }),
                });
                answerIds.forEach(function (answerId) {
                    var condition = _this.questionnaireConditionService.createAnswerConditionEqual(nodeId, answerId, id);
                    var rule = _this.statementService.findNextAvailableRule(statement_2);
                    statement_2 = _this.addConditionToStatement(statement_2, nodeId, rule.id, condition);
                });
                return statement_2;
            }
        }
        else if (Object.values(publish_1.Matcher).includes(defaultMatcher)) {
            console.warn("Matcher " + defaultMatcher + " not yet implemented. Falling back to an empty statement");
        }
        else {
            console.warn("Matcher " + defaultMatcher + " is not recognised. Falling back to an empty statement");
        }
        return new statement_1.Statement({
            id: id,
            rule: rule,
            outcome: new outcome_1.Outcome({
                type: publish_2.OutcomeType.Success,
                params: new next_node_1.NextNode({
                    id: nextNode,
                }),
                reason: '',
            }),
        });
    };
    QuestionnaireLogicService.prototype.buildDefaultRule = function (questionId) {
        return new rule_1.Rule({
            operator: publish_1.Operator.Any,
            conditions: [
                this.questionnaireConditionService.createAnswerConditionEqual(questionId, ''),
            ],
        });
    };
    QuestionnaireLogicService.prototype.buildPassthroughStatement = function (nextQuestion, id) {
        return new statement_1.Statement({
            id: id,
            outcome: new outcome_1.Outcome({
                type: publish_2.OutcomeType.Success,
                params: new next_node_1.NextNode({
                    id: nextQuestion,
                }),
                reason: '',
            }),
        });
    };
    QuestionnaireLogicService.prototype.buildQuestionnaireLogicFromJsonString = function (strQl) {
        return new questionnaire_logic_1.QuestionnaireLogic(JSON.parse(strQl));
    };
    QuestionnaireLogicService.prototype.buildRespondentKnowledgeFromJsonString = function (strKnowledge) {
        return new respondent_knowledge_1.RespondentKnowledge(JSON.parse(strKnowledge));
    };
    QuestionnaireLogicService.prototype.buildDefaultQuestionnaireLogicFromJsonString = function (strQuestionnaire) {
        return this.buildDefaultQuestionnaireLogic(JSON.parse(strQuestionnaire));
    };
    QuestionnaireLogicService.prototype.exportQuestionnaireLogicToJsonString = function (ql) {
        return JSON.stringify(ql);
    };
    QuestionnaireLogicService.prototype.getEmptyRules = function (ql) {
        var _this = this;
        var emptyRules = [];
        ql.nodeStatements.forEach(function (qStatement) {
            qStatement.statements.forEach(function (statement) {
                var leafRules = _this.statementService.getAllLeafRules(statement);
                leafRules.forEach(function (leafRule) {
                    leafRule.conditions.forEach(function (condition) {
                        if (!condition.value) {
                            emptyRules.push(leafRule.id);
                        }
                    });
                });
            });
        });
        return emptyRules;
    };
    /**
     * Reset the logic (statements) of a question and also remove statements
     * from other questions referencing this one in their condition contexts
     *
     * @param {QuestionnaireLogic} ql - The current QuestionnaireLogic object
     * @param {string} id - the id of the question to re-initialized
     * @param {string} nextNode - the id of the next node, so we can initialize the default statement
     *
     */
    QuestionnaireLogicService.prototype.reInitializeNode = function (_a) {
        var _this = this;
        var ql = _a.ql, id = _a.id, nextNode = _a.nextNode, node = _a.node;
        var defaultStatement = new statement_1.Statement({
            outcome: new outcome_1.Outcome({
                type: publish_2.OutcomeType.Success,
                params: new next_node_1.NextNode({
                    id: nextNode,
                }),
                reason: '',
            }),
        });
        var newDefaultStatements = new node_statements_1.NodeStatements({
            nodeId: id,
            statements: [defaultStatement],
        });
        var updatedQl = this.swapNodeStatements(ql, id, newDefaultStatements);
        // here we collect the conditions whose context is referencing the
        // reinitialized node
        // we need to remove these to avoid leaving "dirty" statements
        // Most cases are handled when removing answers or questions
        // but this is for the questions that did not have answers
        // (open ended, numerical open ended, slider, nps) which need
        // to have conditions referencing them, manually removed.
        var conditionsToRemove = [];
        updatedQl.nodeStatements.forEach(function (nStatement) {
            if (nStatement.nodeId !== id) {
                nStatement.statements.forEach(function (statement) {
                    var leafRules = _this.statementService.getAllLeafRules(statement);
                    leafRules.forEach(function (rule) {
                        var ruleId = rule.id;
                        var conditions = _this.ruleService.getConditions(rule);
                        conditions.forEach(function (condition) {
                            var _a, _b;
                            if (((_a = condition.context) === null || _a === void 0 ? void 0 : _a.contextType) ===
                                questionnaire_condition_context_1.QuestionnaireConditionContext.Answer &&
                                ((_b = condition.context) === null || _b === void 0 ? void 0 : _b.questionId) === id) {
                                conditionsToRemove.push({
                                    questionId: nStatement.nodeId,
                                    statementId: statement.id,
                                    ruleId: ruleId,
                                    conditionId: condition.id,
                                });
                            }
                        });
                    });
                });
            }
        });
        conditionsToRemove.forEach(function (_a) {
            var questionId = _a.questionId, statementId = _a.statementId, ruleId = _a.ruleId, conditionId = _a.conditionId;
            try {
                updatedQl = _this.deleteCondition(updatedQl, questionId, statementId, ruleId, conditionId, true);
            }
            catch (e) {
                if (!(e instanceof advanced_logic_error_1.AdvancedLogicError)) {
                    throw e;
                }
            }
        });
        if (node) {
            var currentPosition = lodash_1.findIndex(updatedQl.questionnaire.nodes, [
                'id',
                id,
            ]);
            updatedQl.questionnaire.nodes[currentPosition] = node;
        }
        return updatedQl;
    };
    /* In order for a QuestionnaireLogic to be validated as a basic one we need:
     ** - All rules must only have the "Any" operator
     ** - All conditions must have the "Is" Matcher
     ** - All Outcomes must be of type Success
     ** - Every question needs to have at least one QuestionStatement with no rules (the "In any other case go to")
     ** - There should be no cycles in the tree
     */
    QuestionnaireLogicService.prototype.validateBasicLogic = function (ql) {
        var _this = this;
        var errors = [];
        // TODO: should take into account entry points for the traversal
        lodash_1.forEach(ql.nodeStatements, function (nodeStatements) {
            var hasDefaultStatement = false;
            lodash_1.forEach(nodeStatements.statements, function (statement) {
                if (!statement.rule) {
                    hasDefaultStatement = true;
                }
                if (statement.outcome.type === publish_2.OutcomeType.Failure) {
                    errors.push("Statement \"" + statement.id + "\" contains Outcome of type \"" + publish_2.OutcomeType.Failure + "\", only \"" + publish_2.OutcomeType.Success + "\" is supported for the basic logic");
                }
                errors = errors.concat(_this.validateBasicStatement(statement));
            });
            if (!hasDefaultStatement) {
                errors.push("Question " + nodeStatements.nodeId + " should have at least one statement without a rule (in any other case goto)");
            }
        });
        return errors;
    };
    QuestionnaireLogicService.prototype.validateBasicStatement = function (statement) {
        var errors = [];
        if (statement.outcome.type !== publish_2.OutcomeType.Success) {
            errors.push("Only successful outcomes is available for simple mode. Received outcome type \"" + statement.outcome.type + "\"");
            return errors;
        }
        if (statement.rule) {
            errors = errors.concat(this.validateBasicRule(statement.rule));
        }
        return errors;
    };
    QuestionnaireLogicService.prototype.validateBasicRule = function (rule) {
        var _this = this;
        var errors = [];
        if (rule.operator !== publish_1.Operator.Any) {
            errors.push("Only \"" + publish_1.Operator.Any + "\" operators are available for rules. Received rule operator \"" + rule.operator + "\"");
        }
        if (!lodash_1.isEmpty(rule.conditions)) {
            lodash_1.forEach(rule.conditions, function (conditionOrRule) {
                errors = errors.concat(_this.validateBasicCondition(conditionOrRule));
            });
        }
        return errors;
    };
    QuestionnaireLogicService.prototype.validateBasicCondition = function (conditionOrRule) {
        var errors = [];
        if (this.ruleService.isCondition(conditionOrRule)) {
            if (!lodash_1.includes([
                publish_1.Matcher.Equal,
                publish_1.Matcher.NotEqual,
                publish_1.Matcher.Contains,
                publish_1.Matcher.NotContains,
                publish_1.Matcher.GreaterThan,
                publish_1.Matcher.GreaterThanEqual,
                publish_1.Matcher.LowerThan,
                publish_1.Matcher.LowerThanEqual,
                publish_1.Matcher.ContainsWord,
            ], conditionOrRule.matcher)) {
                errors.push("Only \"" + publish_1.Matcher.Equal + "\", \"" + publish_1.Matcher.NotEqual + "\", \"" + publish_1.Matcher.Contains + "\", \"" + publish_1.Matcher.NotContains + "\"," +
                    (" \"" + publish_1.Matcher.GreaterThan + "\",") +
                    (" \"" + publish_1.Matcher.LowerThan + "\",") +
                    (" \"" + publish_1.Matcher.GreaterThanEqual + "\",") +
                    (" \"" + publish_1.Matcher.LowerThanEqual + "\",") +
                    (" \"" + publish_1.Matcher.ContainsWord + "\",") +
                    (" matchers are available for conditions. Received condition matcher \"" + conditionOrRule.matcher + "\""));
            }
            if (!lodash_1.isUndefined(conditionOrRule.value) &&
                !lodash_1.isNull(conditionOrRule.value)) {
                // this is not possible to happen with the current commit, since valueType is being inferred from the value
                // but we should allow for explicitly providing the expected type
                var valueType = lodash_1.get(conditionOrRule, 'context.valueType', '');
                if (valueType === 'number' && !lodash_1.isNumber(conditionOrRule.value)) {
                    errors.push("For \"" + conditionOrRule.matcher + "\" matcher, expected value to be of type number, received " + typeof conditionOrRule.value);
                }
                if (conditionOrRule.matcher === publish_1.Matcher.Contains &&
                    !lodash_1.isString(conditionOrRule.value)) {
                    errors.push("For \"" + publish_1.Matcher.Contains + "\" matcher, the expected value type is string\"");
                }
                if (conditionOrRule.matcher === publish_1.Matcher.NotContains &&
                    !lodash_1.isString(conditionOrRule.value)) {
                    errors.push("For \"" + publish_1.Matcher.NotContains + "\" matcher, the expected value type is string\"");
                }
                if (conditionOrRule.matcher === publish_1.Matcher.GreaterThan &&
                    !lodash_1.isNumber(conditionOrRule.value)) {
                    errors.push("For \"" + publish_1.Matcher.GreaterThan + "\" matcher, the expected value type is number\"");
                }
                if (conditionOrRule.matcher === publish_1.Matcher.LowerThan &&
                    !lodash_1.isNumber(conditionOrRule.value)) {
                    errors.push("For \"" + publish_1.Matcher.LowerThan + "\" matcher, the expected value type is number\"");
                }
                if (conditionOrRule.matcher === publish_1.Matcher.GreaterThanEqual &&
                    !lodash_1.isNumber(conditionOrRule.value)) {
                    errors.push("For \"" + publish_1.Matcher.GreaterThanEqual + "\" matcher, the expected value type is number\"");
                }
                if (conditionOrRule.matcher === publish_1.Matcher.LowerThanEqual &&
                    !lodash_1.isNumber(conditionOrRule.value)) {
                    errors.push("For \"" + publish_1.Matcher.LowerThanEqual + "\" matcher, the expected value type is number\"");
                }
            }
        }
        if (this.ruleService.isRule(conditionOrRule)) {
            errors = errors.concat(this.validateBasicRule(conditionOrRule));
        }
        return errors;
    };
    QuestionnaireLogicService.prototype.exportBasicLogic = function (ql) {
        var _this = this;
        var errors = this.validateBasicLogic(ql);
        if (!lodash_1.isEmpty(errors)) {
            throw new advanced_logic_error_1.AdvancedLogicError("Received questionnaire logic is not valid \n" + errors.join('\n'));
        }
        var basicLogic = {
            surveyId: ql.questionnaire.surveyId,
            questions: [],
        };
        lodash_1.forEach(ql.nodeStatements, function (nodeStatements) {
            var question = lodash_1.find(ql.questionnaire.nodes, [
                'id',
                nodeStatements.nodeId,
            ]);
            var answers = lodash_1.get(question, 'answers', []);
            var newQuestion = {
                id: nodeStatements.nodeId,
                answers: [],
            };
            lodash_1.forEach(nodeStatements.statements, function (statement) {
                // for every statement without a rule, we override all answers that haven't already got a rule
                if (!statement.rule && lodash_1.has(statement, 'outcome.params.id')) {
                    lodash_1.forEach(answers, function (answer) {
                        var answerHasAlreadyRule = lodash_1.some(newQuestion.answers, [
                            'id',
                            answer.id,
                        ]);
                        if (!answerHasAlreadyRule) {
                            newQuestion.answers.push(__assign(__assign({}, answer), { nextQuestion: statement.outcome.params.id }));
                        }
                    });
                    if (lodash_1.isEmpty(answers)) {
                        newQuestion.nextQuestionRefId = statement.outcome.params.id;
                    }
                }
                else if (statement.rule) {
                    // given the fact that only Any operators are allowed for rules and only equal matchers
                    // for conditions, then our job here becomes much easier
                    var conditions = _this.ruleService.getConditions(statement.rule);
                    var answerIds = lodash_1.flatMap(conditions, 'value');
                    lodash_1.forEach(answerIds, function (answerId) {
                        var answerHasAlreadyRule = lodash_1.some(newQuestion.answers, [
                            'id',
                            answerId,
                        ]);
                        if (!answerHasAlreadyRule) {
                            newQuestion.answers.push({
                                id: answerId,
                                nextQuestion: statement.outcome.params.id,
                            });
                        }
                    });
                }
                else {
                    console.warn("[WARN]: Unsupported type of statement: Statement " + statement.id);
                }
            });
            basicLogic.questions.push(newQuestion);
        });
        return basicLogic;
    };
    QuestionnaireLogicService.prototype.migrate = function (ql) {
        var headId = lodash_1.get(ql, 'entryPoint.statements[0].outcome.params.id', constants_1.FinalNode);
        var newQl = lodash_1.cloneDeep(ql);
        // transform question to nodes
        var questions = lodash_1.get(ql, 'questionnaire.questions', []);
        if (!lodash_1.isEmpty(questions)) {
            newQl.questionnaire.nodes = questions;
            delete newQl.questionnaire.questions;
            var questionStatements = lodash_1.get(newQl, 'questionStatements', []);
            if (!lodash_1.isEmpty(questionStatements)) {
                newQl.nodeStatements = questionStatements.map(function (qStatements) { return ({
                    nodeId: qStatements.questionId,
                    statements: qStatements.statements,
                }); });
                delete newQl.questionStatements;
            }
        }
        var nodes = lodash_1.get(newQl, 'questionnaire.nodes', []);
        if (!lodash_1.isEmpty(nodes) && headId === constants_1.FinalNode) {
            var firstNodeId = nodes[0].id;
            var entryPoint = new questionnaire_entry_point_1.QuestionnaireEntryPoint({
                statements: [this.buildPassthroughStatement(firstNodeId)],
            });
            newQl = this.swapEntryPoint(newQl, entryPoint);
        }
        return newQl;
    };
    QuestionnaireLogicService.prototype.removeChildNode = function (ql, id, nodeId) {
        return __assign(__assign({}, ql), { questionnaire: __assign(__assign({}, ql.questionnaire), { nodes: ql.questionnaire.nodes.map(function (node) {
                    var _a;
                    if (node.id === id) {
                        return __assign(__assign({}, node), { nodes: (_a = node.nodes) === null || _a === void 0 ? void 0 : _a.filter(function (node) { return node.id !== nodeId; }) });
                    }
                    return node;
                }) }) });
    };
    QuestionnaireLogicService.prototype.updateChildNodes = function (ql, id, nodes) {
        return __assign(__assign({}, ql), { questionnaire: __assign(__assign({}, ql.questionnaire), { nodes: ql.questionnaire.nodes.map(function (node) {
                    if (node.id === id) {
                        return __assign(__assign({}, node), { nodes: nodes });
                    }
                    return node;
                }) }) });
    };
    return QuestionnaireLogicService;
}());
exports.QuestionnaireLogicService = QuestionnaireLogicService;
